<template>
  <div
    class="wrapper"
    :data-open="state === 'open' ? 1 : 0"
  >
    <div
      class="bg"
      @click="() => setState('half')"
    />
    <div
      ref="card"
      class="card"
      :data-state="isMoving ? 'move' : state"
      :style="{ 
        top: `${isMoving ? y : calcY()}px`, 
      }"
      :class="{ scrolling: scrolling === true }"
    >
      <div
        ref="pan"
        class="pan-area"
      >
        <div
          ref="bar"
          class="bar"
          :style="{ backgroundColor: barColor }"
        />
      </div>
      <div
        ref="scroller"
        class="contents"
        :class="{ 'scrolling': scrollerTop }"
      >
        <slot />
        <button
          v-show="scrollerTop && state === 'open'"
          type="button"
          class="scrolltop-button"
          @click="handleClickScrollTop"
        >
          <img
            src="/theme/rbFront/img/w/case-study/mobile/arrow_top.png"
            alt=""
          >
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Hammer from "hammerjs";
export default {
  name: "BottomSheet",
  props: {
    openY: {
      type: Number,
      default: 0.1,
    },
    halfY: {
      type: Number,
      default: 0.7,
    },
    defaultState: {
      type: String,
      default: "close",
    },
    barColor: {
      type: String,
      default: "rgba(0, 0, 0, .3)",
    },
    value: {
      type: String,
      default: "half",
    },
    minState: {
      type: String,
      default: "close",
    },
    region: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mc: null,
      y: 0,
      startY: 0,
      isMoving: false,
      state: this.defaultState,
      rect: {},
      states: ["close", "half", "open"],
      scrollerTop: 0,
      viewportHeight: 0,
      scrollTimeout: null,
      scrolling: false
    };
  },
  computed: {
    scrollerOffsetTop() {
      return this.$refs.scroller.scrollTop
    }
  },
  watch: {
    value(newState) {
      this.setState(newState);
    },
    state(newState) {
      if (this.sheetState !== newState) {
        this.$emit("input", newState);
      }
    },
    region: {
      immediate: true,
      handler() {
        this.handleClickScrollTop()
      }
    },
  },
  mounted() {
    this.$refs.scroller.addEventListener('scroll', this.scrollerScrollEventListener)
    window.onresize = () => {
      this.rect = this.$refs.card.getBoundingClientRect();
      this.viewportHeight = window.innerHeight
    };
    window.onscroll = () => {
      this.scrolling = true
      this.screenHeight = screen.height
      this.viewportHeight = window.innerHeight
      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = setTimeout(() => {
        this.scrolling = false
        console.log('스크롤 이벤트가 마무리 되었습니다.');
      }, 250)
    }
    this.rect = this.$refs.card.getBoundingClientRect();
    this.viewportHeight = window.innerHeight
    this.mc = new Hammer(this.$refs.pan);
    this.mc.get("pan").set({ direction: Hammer.DIRECTION_ALL });
    this.mc.on("panup pandown", (evt) => {
      this.y = evt.center.y - 16;
    });
    this.mc.on("panstart", (evt) => {
      this.startY = evt.center.y;
      this.isMoving = true;
    });
    this.mc.on("panend", (evt) => {
      this.isMoving = false;
      switch (this.state) {
        case "close": //Added a close state on the condition to be able to swipe from closed to half/closed state.
        case "half":
          if (this.state === "close") {
            if (this.startY - evt.center.y > 120) {
              this.state = "half";
            }
            if (this.startY - evt.center.y > 320) {
              this.state = "open";
            }
            break;
          }
          if (this.startY - evt.center.y > 120) {
            this.state = "open";
          }
          if (this.startY - evt.center.y < -50) {
            this.state = "close";
          }
          break;
        case "open":
          if (this.startY - evt.center.y < -120) {
            this.state = "half";
          }
          break;
        default:
          this.state = "half";
      }
      this.checkForMinState();
    });
    this.checkForMinState();
  },
  beforeDestroy() {
    this.$refs.scroller.removeEventListener('scroll', this.scrollerScrollEventListener)
    this.mc.destroy();
    window.onresize = null;
  },
  methods: {
    scrollerScrollEventListener() {
      this.scrollerTop = this.$refs.scroller.scrollTop
    },
    calcY() {
      switch (this.state) {
        case "close":
          return (this.viewportHeight * 0.9)
        case "open":
          return (this.viewportHeight * this.openY)
        case "half":
          return (this.viewportHeight * this.halfY);
        default:
          return this.y;
      }
    },
    checkForMinState() {
      if (
        this.states.indexOf(this.state) < this.states.indexOf(this.minState)
      ) {
        this.state = this.minState;
      }
    },
    setState(state) {
      this.state = state;
    },
    handleClickScrollTop() {
      if (this.$refs.scroller) {
        this.$refs.scroller.scrollTop = 0
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.wrapper[data-open="1"] {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}

.wrapper[data-open="1"] .bg {
  display: block;
  transition: all 0.3s;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.card {
  width: 100%;
  height: 100vh;
  position: fixed;
  background: white;
  border-radius: 30px 30px 0 0;
  box-shadow: 0px -3px 5.76px 0.24px rgba(0, 0, 0, 0.08);
  left: 0;
  z-index: 100;
}

.card[data-state="half"],
.card[data-state="open"],
.card[data-state="close"] {
  transition: top .3s ease-out;
  &.scrolling {
    transition: none;
  }
}

.card[data-state="close"] {
  // box-shadow: none;
}

.bar {
  width: 45px;
  height: 8px;
  border-radius: 14px;
  margin: 0 auto;
  cursor: pointer;
}

.pan-area {
  top: 0;
  right: 0;
  left: 0;
  position: absolute;
  padding: 18px 0;
  .bar {
    &:hover {
      cursor: grab;
    }
    &:active {
      cursor: grabbing;
    }
  }
}

.card[data-state="close"] .pan-area {
  // top: -28px;
}

.scrolltop-button {
  width: calc(((101 / 720) * 100) * 1vw);
  height: calc(((43 / 720) * 100) * 1vw);
  background-color: #fff;
  position: fixed;
  z-index: 10;
  left: 50%;
  bottom: calc(((28 / 720) * 100) * 1vw);
  transform: translateX(-50%);
  border: 1px solid #000;
  border-radius: 20px;
  box-shadow: 0px 3px 9.6px 0.4px rgba(0, 0, 0, 0.13);

  img {
    width: calc(((27 / 720) * 100) * 1vw);
    height: calc(((16 / 720) * 100) * 1vw);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.Up_button {
  border-width: 1px;
  border-color: rgb(0, 0, 0);
  border-style: solid;
  background-color: rgb(255, 255, 255);
  
  left: 309px;
  top: 1464px;
  width: 101px;
  height: 43px;
  z-index: 574;
}


.contents {
  margin-top: 44px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;
  padding-bottom: calc(100vh * 0.2);
  box-sizing: border-box;
}
</style>